import {
  SKL_DATA_NAMESPACE as SKL_DATA_NAMESPACE_VOCAB,
  SKL_ENGINE,
  SKL_ENGINE_NAMESPACE as SKL_ENGINE_NAMESPACE_VOCAB,
  SKL_NAMESPACE as SKL_NAMESPACE_VOCAB,
  SKL_PROPERTY,
  SKL_SPECS
} from './util/Vocabularies';
import {
  OWL as OWL_VOCAB,
  R2RML as R2RML_VOCAB,
  RDF as RDF_VOCAB,
  RDFS as RDFS_VOCAB, SHACL as SHACL_VOCAB, SHACL_NAMESPACE as SHACL_NAMESPACE_VOCAB, XSD as XSD_VOCAB
} from './util/Vocabularies/Shared';

export const SKL_NAMESPACE = SKL_NAMESPACE_VOCAB;
export const SKL_DATA_NAMESPACE = SKL_DATA_NAMESPACE_VOCAB;
export const SKL_ENGINE_NAMESPACE = SKL_ENGINE_NAMESPACE_VOCAB;

export const OWL = OWL_VOCAB;
export const RDF = RDF_VOCAB;
export const RDFS = RDFS_VOCAB;
export const R2RML = R2RML_VOCAB;
export const XSD = XSD_VOCAB;
export const SHACL = SHACL_VOCAB;
export const SHACL_NAMESPACE = SHACL_NAMESPACE_VOCAB;
export const PROP_ENTITY_ID = '@id';
export const PROP_ENTITY_TYPE = '@type';
export const PROP_ENTITY_VALUE = '@value';

// RML constants

export const RML_LIST = '@list';

export const OPEN_API_RUNTIME_AUTHORIZATION = 'getOpenApiRuntimeAuthorization';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const EngineConstants = {
  spec: {
    capability: SKL_SPECS.Capability,
    capabilityMapping: SKL_SPECS.CapabilityMapping,
    triggerCapabilityMapping: SKL_SPECS.TriggerCapabilityMapping,
    invalidTokenErrorMatcher: SKL_SPECS['integration/InvalidTokenErrorMatcher'],
    jsonDataSource: SKL_SPECS.JsonDataSource,
    mapping: SKL_SPECS.Mapping,
    inputs: SKL_SPECS.Inputs,
    openApi: SKL_SPECS.OpenAPI,
    codeBlock: SKL_SPECS.CodeBlock,
    integrationAuthenticationCredential: SKL_SPECS['integration/AuthenticationCredential'],
    integrationInterface: SKL_SPECS['integration/IntegrationInterface']
  },
  prop: {
    capability: SKL_PROPERTY.capability,
    inputs: SKL_PROPERTY.inputs,
    outputs: SKL_PROPERTY.outputs,
    inputsContext: SKL_PROPERTY.inputsContext,
    outputsContext: SKL_PROPERTY.outputsContext,
    invalidTokenErrorMatcher: SKL_PROPERTY['integration/invalidTokenErrorMatcher'],
    invalidTokenErrorMatcherStatus: SKL_PROPERTY['integration/invalidTokenErrorMatcherStatus'],
    invalidTokenErrorMatcherMessageRegex: SKL_PROPERTY['integration/invalidTokenErrorMatcherMessageRegex'],
    refreshCapability: SKL_PROPERTY['integration/refreshCapability'],
    refreshToken: SKL_PROPERTY['integration/credential/refreshToken'],
    jwtBearerOptions: SKL_PROPERTY['integration/credential/jwtBearerOptions'],
    accessToken: SKL_PROPERTY['integration/credential/accessToken'],
    bearerToken: SKL_PROPERTY['integration/credential/bearerToken'],
    username: SKL_PROPERTY['integration/username'],
    password: SKL_PROPERTY['integration/password'],
    oneTimePassword: SKL_PROPERTY['integration/oneTimePassword'],
    apiKey: SKL_PROPERTY['integration/apiKey'],
    declarativeApiDescription: SKL_PROPERTY['integration/declarativeApiDescription'],
    overrideBasePath: SKL_PROPERTY['integration/overrideBasePath'],
    schemeName: SKL_PROPERTY['integration/schemeName'],
    oauthFlow: SKL_PROPERTY['integration/oauthFlow'],
    stage: SKL_PROPERTY['integration/stage'],
    operationId: SKL_PROPERTY.operationId,

    data: SKL_PROPERTY.data,
    source: SKL_PROPERTY.source,
    headers: SKL_PROPERTY.headers,
    object: SKL_PROPERTY.object,
    dataSource: SKL_PROPERTY.dataSource,

    series: SKL_PROPERTY['mapping/series'],
    parallel: SKL_PROPERTY['mapping/parallel'],
    inputsReference: SKL_PROPERTY['mapping/inputsReference'],
    inputsMapping: SKL_PROPERTY['mapping/inputsMapping'],
    inputsMappingFrame: SKL_PROPERTY['mapping/inputsMappingFrame'],
    inputsMappingRef: SKL_PROPERTY['mapping/inputsMappingRef'],
    inputsMappingFrameRef: SKL_PROPERTY['mapping/inputsMappingFrameRef'],
    outputsMapping: SKL_PROPERTY['mapping/outputsMapping'],
    outputsMappingFrame: SKL_PROPERTY['mapping/outputsMappingFrame'],
    preProcessingMapping: SKL_PROPERTY['mapping/preProcessingMapping'],
    preProcessingMappingFrame: SKL_PROPERTY['mapping/preProcessingMappingFrame'],
    operationMapping: SKL_PROPERTY['mapping/operationMapping'],

    type: SKL_PROPERTY.type,
    dateCreated: SKL_PROPERTY.dateTimeCreated,
    dateModified: SKL_PROPERTY.dateTimeModified,
    label: SKL_PROPERTY.label,
    identifier: SKL_PROPERTY.identifier,
    codeBody: SKL_PROPERTY['content/codeBody'],
    codeBlocks: SKL_PROPERTY['content/codeBlocks'],
    integration: SKL_PROPERTY['integration/integration'],
    accountOrUser: SKL_PROPERTY.accountOrUser,

    capabilityType: SKL_PROPERTY.capabilityType
  },
  dataSource: {
    update: SKL_ENGINE.update,
    findAll: SKL_ENGINE.findAll,
    findAllBy: SKL_ENGINE.findAllBy,
    find: SKL_ENGINE.find,
    findBy: SKL_ENGINE.findBy,
    exists: SKL_ENGINE.exists,
    existsResult: SKL_ENGINE.existsResult,
    count: SKL_ENGINE.count,
    countResult: SKL_ENGINE.countResult,
    save: SKL_ENGINE.save,
    destroy: SKL_ENGINE.destroy
  }
};
